export const userProfile = {
  user_alias: "昵称",
  user_name: "名字",
  user_lastName: "姓氏",
  user_email: "电子邮件",
  user_phoneNumber: "电话号码",
  user_birthdate: "出生日期",
  user_national_id: "身份证",
  user_state: "省份",
  user_city: "城市",
  user_support_message: "要对您的个人资料进行任何更改或更新，请联系我们的",
  user_support_link: "技术支持",

  userProfileImageFormat: "不支持的格式",
  userProfileImageFormatDesc: "只允许JPEG、JPG或PNG格式的图片。",
  userProfileImageSize: "图片太大",
  userProfileImageSizeDesc: "允许的最大大小为3MB。",
  userProfileImageEdit: "编辑",

  profileFollowers: "关注者",
  profileFollowing: "关注中",
  profileFavoriteGames: "收藏游戏",
  profileRecentGames: "最近玩过",
  profileFavoriteProviders: "已关注供应商",
  profileEditProfile: "编辑资料",
  profileKeepPlaying: "继续游戏",
  profileFollow: "关注",
  profileNoFavorites: "还没有收藏游戏",
  profileNoFavoritesDesc: "您收藏的游戏将显示在这里",
  profileNoRecentGames: "没有最近的游戏",
  profileNoRecentGamesDesc: "您玩过的游戏将显示在这里",
  profileNoProviders: "还没有关注任何供应商",
  profileGamesCount: "{{count}} 款游戏",

  profileHighlightBigWins: "大奖",
  profileHighlightFavorites: "收藏",
  profileHighlightRecent: "最近",
  profileHighlightLatestWinners: "最近赢家",
  profileHighlightPopularGames: "热门游戏",
  profileHighlightLastPlayed: "最近玩过",
  profileHighlightNoWins: "暂无大奖记录",

  profileFeedTabs: "个人资料标签",
  profileNoBigWins: "暂无大奖",
  profileNoBigWinsDesc: "您的获奖时刻将显示在这里",

  profileNoFollowers: "暂无关注者",
  profileNoFollowing: "暂未关注任何人",
  profileFollowersSoon: "此功能即将推出",

  friendAddFriend: "关注",
  friendStatusPending: "已发送请求",
  friendStatusFriends: "好友",
  friendRequestSentToast: "好友请求已发送",
  friendRequestSentTitle: "请求已发送",
  friendRequestSentBody: "您的好友请求已发送",
  friendRequestReceivedTitle: "好友请求",
  friendRequestReceivedBody: "{{alias}} 向您发送了好友请求",
  friendUnfriendTitle: "解除好友？",
  friendUnfriendDescription: "您确定要解除与 @{{alias}} 的好友关系吗？",
  friendUnfriendConfirm: "确认",
  friendUnfriendCancel: "取消",
  friendUnfriendLoading: "移除中...",
};
